/* Polygoa - cartes d'offre (Solo / Duo / Trio) construites à partir des variantes du produit + libellé du bouton d'achat. Le sélecteur natif du thème reste la source de vérité (il est simplement masqué). */
(function () {
  var CFG = {
    solo: { n: 1, name: 'Solo « Pour moi »', meta: '1 paire + guide de démarrage' },
    duo: { n: 2, name: 'Duo « Pour nous deux »', meta: '2 paires + guide de démarrage', badge: 'Notre choix', tone: 'y' },
    trio: { n: 3, name: 'Trio « Pour toute la bande »', meta: '3 paires + guide de démarrage', badge: 'Meilleure économie', tone: 'b' }
  };
  function key(t) {
    t = (t || '').toLowerCase();
    return t.indexOf('solo') > -1 ? 'solo' : t.indexOf('duo') > -1 ? 'duo' : t.indexOf('trio') > -1 ? 'trio' : null;
  }
  function esc(s) {
    return String(s).replace(/[&<>\"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[c]; });
  }
  function init(box) {
    if (box.getAttribute('data-pg-ready')) return;
    box.setAttribute('data-pg-ready', '1');
    var root = box.closest('section') || document;
    var picker = root.querySelector('variant-selects');
    if (!picker) { box.remove(); return; }
    var handle = picker.getAttribute('data-product-handle');
    var cur = picker.getAttribute('data-currency-code') || 'EUR';
    var lang = document.documentElement.lang || 'fr-FR';
    var f2 = new Intl.NumberFormat(lang, { style: 'currency', currency: cur });
    var f0 = new Intl.NumberFormat(lang, { style: 'currency', currency: cur, maximumFractionDigits: 0 });
    var cta = box.getAttribute('data-cta') || "Je pars l'esprit léger";
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var vs = p.variants;
      if (!vs || vs.length < 2) { box.remove(); return; }
      var base = vs[0].price;
      var html = '';
      vs.forEach(function (v, i) {
        var k = key(v.option1 || v.title);
        var c = CFG[k] || { n: i + 1 };
        var n = c.n;
        var save = base * n - v.price;
        html += '<button type=\"button\" role=\"radio\" class=\"pg-offer\" aria-checked=\"false\" data-value=\"' + esc(v.option1 || v.title) + '\"' + (v.available ? '' : ' disabled') + '>' +
          (c.badge ? '<span class=\"pg-offer__badge pg-offer__badge--' + (c.tone || 'y') + '\">' + esc(c.badge) + '</span>' : '') +
          '<span class=\"pg-offer__row\">' +
          '<span class=\"pg-offer__left\"><span class=\"pg-offer__name\">' + esc(c.name || v.title) + '</span>' +
          '<span class=\"pg-offer__meta\">' + esc(c.meta || '') + '</span>' +
          (save > 0 ? '<span class=\"pg-offer__save\">Économisez ' + f2.format(save / 100) + '</span>' : '') + '</span>' +
          '<span class=\"pg-offer__right\"><span class=\"pg-offer__price\">' + f2.format(v.price / 100) + '</span>' +
          (n > 1 ? '<span class=\"pg-offer__per\">soit ' + f0.format(Math.round(v.price / n / 100)) + ' la paire</span>' : '') + '</span>' +
          '</span></button>';
      });
      box.innerHTML = html;
      box.setAttribute('role', 'radiogroup');
      box.setAttribute('aria-label', 'Choisis ton offre');
      box.hidden = false;
      root.classList.add('pg-enhanced');
      function radio(val) {
        var inputs = picker.querySelectorAll('input[type=radio]');
        for (var i = 0; i < inputs.length; i++) if (inputs[i].value === val) return inputs[i];
        return null;
      }
      function selected() {
        var checked = picker.querySelector('input[type=radio]:checked');
        return checked ? checked.value : null;
      }
      function sync() {
        var val = selected();
        box.querySelectorAll('.pg-offer').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-value') === val ? 'true' : 'false'); });
      }
      /* libellé du bouton d'achat : texte seul, sans prix (le prix est déjà sur la carte d'offre) */
      function applyCta() {
        var btn = root.querySelector('button[type=submit][name=add]');
        if (!btn || btn.disabled) return;
        var span = btn.querySelector('span');
        if (!span) return;
        if (span.textContent.trim() !== cta) span.textContent = cta;
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.pg-offer');
        if (!b || b.disabled) return;
        var r = radio(b.getAttribute('data-value'));
        if (r && !r.checked) r.click();
        setTimeout(function () { sync(); applyCta(); }, 0);
      });
      picker.addEventListener('change', function () { setTimeout(function () { sync(); applyCta(); }, 0); });
      if (!new URLSearchParams(window.location.search).has('variant')) {
        for (var i = 0; i < vs.length; i++) {
          if (key(vs[i].option1 || vs[i].title) === 'duo' && vs[i].available) {
            var r = radio(vs[i].option1 || vs[i].title);
            if (r && !r.checked) r.click();
          }
        }
      }
      sync();
      applyCta();
      new MutationObserver(function () { applyCta(); }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    }).catch(function () { box.remove(); });
  }
  function run() { document.querySelectorAll('[data-pg-offers]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();